import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-category-report',
  templateUrl: './category-report.component.html',
  styleUrls: ['./category-report.component.css']
})
export class CategoryReportComponent implements OnInit, OnDestroy {

  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  category: string;
  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  type: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;
  dataLoaded: boolean;
  usrs = [];
  searchUser: FormControl = new FormControl();
  isLoading: boolean;
  userId: number;
  userName: string;
  userSelected: string;
  hidePagination: boolean;
  isCategory: boolean;
  support_group = [];
  sgroupSelected = [];
  isGrpFilter: boolean;
  isUserFilter: boolean;
  dataExcel = [];

  isExportDisable = false;

  @ViewChild('content') private content;
  private searchModalReference: NgbModalRef;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
          }
          break;
      }
    });
  }


  ngOnInit() {
    this.isGrpFilter = false;
    this.isUserFilter = false;
    this.userId = 0;
    this.hidePagination = true;
    this.dataLoaded = true;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Analyst category filter report',
      openModalButton: 'Analyst category filter report',
      breadcrumb: 'Analyst category filter report',
      folderName: 'Analyst category filter report',
      tabName: 'Analyst category filter report'
    };
    const columnDefinitions = [
      {
        id: 'name', name: 'User Name ', field: 'user_name', sortable: true, filterable: true, minWidth: 200
      },
      {
        id: 'login_id', name: 'Login Id ', field: 'loginId', sortable: true, filterable: true, minWidth: 200
      },
      {
        id: 'support_group', name: 'Support Group', field: 'support_group', sortable: true, filterable: true, minWidth: 200
      },
      {
        id: 'ic', name: 'IC ', field: 'ic', sortable: true, filterable: true, minWidth: 200
      },
      {
        id: 'legal_entity', name: 'Legal Entity', field: 'legal_entity', sortable: true, filterable: true, minWidth: 200
      },
      {
        id: 'strategic_business_group', name: 'Strategic Business Group', field: 'strategic_business_group', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'business_unit', name: 'Business Unit ', field: 'business_unit', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'segment', name: 'Segment', field: 'segment', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'cluster', name: 'Cluster', field: 'cluster', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'department', name: 'Department', field: 'department', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'location', name: 'Location', field: 'location', sortable: true, filterable: true, minWidth: 150
      },
      {
        id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true, minWidth: 200
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
    this.searchUser.valueChanges.subscribe(
        psOrName => {
          if (psOrName !== undefined && psOrName.length > 4) {
            this.isLoading = true;
            const role_id = 0;
            this.userName = '';
            this.userSelected = '';
            this._rest.searchAnalystByPsNo(this.clientId, psOrName).subscribe((res1) => {
              this.respObject = res1;
              this.isLoading = false;
              if (this.respObject.success) {
                this.usrs = this.respObject.details;
              } else {
                this.notifier.notify('error', this.respObject.errorMessage);
              }
            }, (err) => {
              this.isLoading = false;
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
          } else {
            this.usrs = [];
          }
        });
  }

  onPageLoad() {
    this.isGrpFilter = false; 
    this.isUserFilter = false;
    this._rest.getUserSupportGroup(this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
          this.support_group = this.respObject.details;
      } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
      }
  }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
  });
    // this.getTableData();
  }


  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getUserDetails() {
    for (let i = 0; i < this.usrs.length; i++) {
      if (this.usrs[i].login_name === this.userSelected) {
        this.userId = this.usrs[i].id;
        this.userName = this.usrs[i].name;
      }
    }
  }

  openModal() {
    this.isGrpFilter = false;
    this.isUserFilter = false;

    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.usrs = [];
      this.sgroupSelected = [];
      this.searchModalReference = this.modalService.open(this.content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });
    }
  }

  search() {
    if (this.usrs.length === 0) {
      this.isError = true;
      this.errorMessage = 'Enter the login id or login name';
    } else {
      this.isError = false;
      // console.log('userId===' + this.userId);
      this._rest.getCategoryReportUserWise(this.clientId, this.userId).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.page_no = 1;
          const data1 = this.respObject.details;
          this.messageService.setTotalData(1);
          this.messageService.setGridData(data1);
          this.searchModalReference.close();
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }


  exportToExcel() {
    this.isExportDisable = true;
    this._rest.getCategoryReportSupportGroupWise(this.clientId , this.sgroupSelected).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;

            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }



  UserFilter(){
  this.isGrpFilter = false;
  this.isUserFilter = true;
  }


  sGrpFilter(){
this.isGrpFilter = true;
this.isUserFilter = false;
  }
}
